const business = {
    address: "Seternity Solutions, Head Office, Ground Floor, Mayur Van Area Udaipur, 313001, Rajasthan, India",
    supportEmail: "support@seternitysolutions.com",
    salesEmail: "sales@seternitysolutions.com",
    phone: "+919680585289",
    phoneDisplay: "+91 9680585289",
    linkedin: "https://www.linkedin.com/company/seternity-solutions",
    facebook: "https://www.facebook.com/seternitysolutions/",
    zoominfo: "https://www.zoominfo.com/c/seternity-solutions-companies/397522892",
    pitchbook: "https://pitchbook.com/profiles/advisor/519811-21"
};

const companyLinks = [
    { id: 1, label: "About Us", href: "/about-us" },
    { id: 2, label: "Services", href: "/" },
    { id: 3, label: "Client Segments", href: "/" },
    { id: 5, label: "Insights", href: "/insights" },
    { id: 4, label: "Careers", href: "/career" },
];

const footerCompanyLinks = [
    { id: 1, label: "About Us", href: "/about-us" },
    { id: 5, label: "Insights", href: "/insights" },
    { id: 4, label: "Careers", href: "/career" },
];

const social = [
    { title: "LinkedIn", image: "/images/linkedin.png", url: business.linkedin },
    { title: "Facebook", image: "/images/facebook.png", url: business.facebook },
    { title: "ZoomInfo", image: "/images/zoominfo.png", url: business.zoominfo },
    { title: "PitchBook", image: "/images/pitchbook.png", url: business.pitchbook }
];

const clientSegmentsLinks = [
    { label: "Private Equity", href: "/client-segment/private-equity" },
    { label: "Search funds", href: "/client-segment/search-funds" },
    { label: "Investment Banks", href: "/client-segment/investment-banks" },
    { label: "Consultants", href: "/client-segment/consultants" },
    { label: "Small Business and Startups", href: "/client-segment/small-business-and-startups" },
    { label: "Accounting Firms", href: "/client-segment/accounting-firms" }
];

const capabilitiesLinks = [
    { label: "Accounting & Bookkeeping", href: "/services/accounting-and-bookkeeping" },
    { label: "Capital Market Research", href: "/services/capital-market-research" },
    { label: "Investment & Transaction Advisory", href: "/services/investment-transaction-advisory" },
    { label: "Market Research", href: "/services/market-research" },
    { label: "Business Development", href: "/services/business-development" },
    { label: "Data Analytics", href: "/services/data-analytics" },
    { label: "Email Finder", href: "/email-finder" }
];
export {
    business,
    companyLinks,
    footerCompanyLinks,
    social,
    clientSegmentsLinks,
    capabilitiesLinks
}
